import React, { ReactElement, useState, useEffect, useContext } from 'react';
import classnames from 'classnames/bind';
import styles from './PageWrapper.module.scss';
import Head from 'next/head';
import {
  PageHeader,
  PageFooter,
  AppSnackbar
} from '@components';
import { HEAD_TITLES } from '@constants';
import { useGoogleShoppingAgent } from 'hooks';
import { CXAgentStudioMessenger } from 'components/CXAgentStudioMessenger/CXAgentStudioMessenger';
import { ChatbotWidget } from 'components/ChatbotWidget/ChatbotWidget';
import { isFeatureEnabled, FEATURES } from '@utils/featureFlags';
import { UserContext } from '@utils';

const CN = 'page-wrapper';
const cx = classnames.bind(styles);

interface PageWrapperProps {
  children: ReactElement | ReactElement[];
  hasHeader?: boolean;
  hasFooter?: boolean;
  showChatbotWidget?: boolean;
}

export const PageWrapper: React.FC<PageWrapperProps> = ({
  children,
  hasHeader = false,
  hasFooter = false,
  showChatbotWidget = true
}) => {
  const [ isClient, setIsClient ] = useState(false);
  const { user } = useContext(UserContext);
  useGoogleShoppingAgent();

  useEffect(() => {
    setIsClient(true);
  }, []);

  return (
    <>
      <Head>
        <title>{HEAD_TITLES.HomePage}</title>
      </Head>
      <div className={ cx(CN) }>
        {hasHeader && (
          isClient ? (
            <PageHeader />
          ) : (
            <div className={ cx(`${CN}--header-skeleton`) } />
          )
        )}
        <main>{children}</main>
        {hasFooter && <PageFooter />}
        <AppSnackbar />
        {isClient && showChatbotWidget && isFeatureEnabled(FEATURES.CX_AGENT_STUDIO) && <CXAgentStudioMessenger />}
        {isClient && showChatbotWidget && isFeatureEnabled(FEATURES.CCAI_WIDGET) && (
          <ChatbotWidget
            host={ process.env.NEXT_PUBLIC_CCAI_HOST }
            companyId={ process.env.NEXT_PUBLIC_CCAI_COMPANY_ID }
            menuId={ Number(process.env.NEXT_PUBLIC_CCAI_MENU_ID) }
            apiUrl={ `${process.env.NEXT_PUBLIC_API_BASE_URL}/ccai` }
            logoUrl='/logo.svg'
            user={ { name: `${user?.firstName ?? ''} ${user?.lastName ?? ''}`.trim(), email: user?.email ?? '' } }
          />
        )}
      </div>
    </>
  );
};
